"use strict";

// alk dependency

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fleetlink = require("./fleetlink.config");

var _fleetlink2 = _interopRequireDefault(_fleetlink);

var _fleetlink3 = require("./fleetlink.vehicles");

var _fleetlink4 = _interopRequireDefault(_fleetlink3);

var _fleetlink5 = require("./fleetlink.vehicle-groups");

var _fleetlink6 = _interopRequireDefault(_fleetlink5);

var _fleetlink7 = require("./fleetlink.drivers");

var _fleetlink8 = _interopRequireDefault(_fleetlink7);

var _fleetlink9 = require("./fleetlink.driver-groups");

var _fleetlink10 = _interopRequireDefault(_fleetlink9);

var _fleetlink11 = require("./fleetlink.routing-profiles");

var _fleetlink12 = _interopRequireDefault(_fleetlink11);

var _fleetlink13 = require("./fleetlink.api");

var _fleetlink14 = _interopRequireDefault(_fleetlink13);

var _fleetlink15 = require("./fleetlink.user");

var _fleetlink16 = _interopRequireDefault(_fleetlink15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module("alk.fleetportal", []).constant("alk.fleetportal.config", _fleetlink2.default).service("Vehicles", _fleetlink4.default).service("Drivers", _fleetlink8.default).service("VehicleGroups", _fleetlink6.default).service("DriverGroups", _fleetlink10.default).service("RoutingProfiles", _fleetlink12.default).service("Users", _fleetlink16.default).service("FleetPortalAPI", _fleetlink14.default).name;


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/index.js